import * as React from 'react'
import { format } from 'date-fns'
import Svg from 'svg'
import conviousLogo from 'images/convious-logo.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faPrint } from '@fortawesome/pro-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import LocationRegular from '../icons/locationRegular.svg'
import '../styles.scss'

interface PrintViewHeaderProps {
    selectedDate: Date
    locationName?: string
}

const PrintViewHeader = ({ selectedDate, locationName }: PrintViewHeaderProps) => {
    return (
        <div className="print-header">
            <Svg className="convious-logo" src={conviousLogo} />
            <div className="print-header-date-container">
                <div>
                    <FontAwesomeIcon className="icon" icon={faCalendarAlt as IconProp} />
                    {format(selectedDate, 'dd/MM/yyyy')}{' '}
                </div>
                <div>
                    <FontAwesomeIcon className="icon" icon={faPrint as IconProp} />
                    {format(new Date(), 'dd/MM/yyyy')}
                </div>
                {locationName && locationName !== '' && (
                    <div>
                        <LocationRegular className="location-icon" />
                        {locationName}
                    </div>
                )}
            </div>
        </div>
    )
}

export default PrintViewHeader
